import { render, staticRenderFns } from "./CashupExpenses.vue?vue&type=template&id=e8796af2"
import script from "./CashupExpenses.vue?vue&type=script&lang=js"
export * from "./CashupExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports